import axios from 'axios'

export default class Estado {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/unimed/enderecos/estados`
    this.tokenBearer = tokenBearer
  }

  getEstados () {
    return new Promise(async (resolve, reject) => {
      let optionsEstado = {
        method: 'get',
        url: `${this.url}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseEstado = await axios(optionsEstado)
        resolve(responseEstado)
      } catch (err) {
        reject(err)
      }
    })
  }
}
